module.exports = __webpack_public_path__ + "static/ColorfacesWithMargin-b120945703ff8de835f9f00e7c9eafae.svg";